module.exports = __webpack_public_path__ + "static/media/desktop_map_ui.213670d0.png";